import React from 'react';
import { get, del, post, put, patch } from '../../../../../../GlobalModules/Utility/Http'
import { getGenericModel, customerListGet } from '../Model/CouponModel';

import * as Store from '../../../../../../store'
let version = Object.keys(Store.default.getState().LoginReducer.userCredentials).length > 0 ? Store.default.getState().LoginReducer.userCredentials.user_details.version : "";


export const CouponApiGetList = async (data) => {
    let queryParams = {};

    if (data) {
        const filtersObj = {
            org_id: data.org_id,
            limit: data.limit || 10,
            page: data.offset !== undefined ? Math.floor(data.offset / (data.limit || 10)) + 1 : 1,
            want_to_fetch_mappings: true
        };

        if (data.search) {
            queryParams.filter_op = JSON.stringify({ code: "substring" });
            filtersObj.code = data.search;
        }

        if (data.sort && data.sort.length > 0) {
            filtersObj.sort = data.sort.map(item => ({
                colId: item.field,
                sort: item.sort
            }));
        }

        if (data.start_date) {
            filtersObj.start_date = data.start_date;
        }

        if (data.end_date) {
            filtersObj.end_date = data.end_date;
        }

        queryParams.filters = JSON.stringify(filtersObj);
    }

    const response = await get(`${process.env.EXTENDED_URL}/coupon/list`, queryParams);
    return getGenericModel(response);
};

export const CouponApiPatch = async (data) => {
    const response = await patch(`${process.env.EXTENDED_URL}/generic/`, data);
    return getGenericModel(response);
}
export const CouponApiPost = async (data) => {
    const response = await post(`${process.env.EXTENDED_URL}/generic/`, data);
    return getGenericModel(response);
}

export const assignCouponApiPost = async (data) => {
    const response = await post(`${process.env.EXTENDED_URL}/coupon/assign/`, data);
    return getGenericModel(response);
}
export const getStoreList = async () => {
  const queryParams = {
    filters: JSON.stringify({ status: true })
  };
  const response = await get(`${process.env.EXTENDED_URL}/store/allow_sell`, queryParams);
  return getGenericModel(response);
};

export const getCustomerList = async (filters = {}) => {
  let queryParams = {};

  if (filters) {
    if (filters.search) {
      queryParams.filter_op = JSON.stringify({ search_attr: "substring" });
      queryParams.filters = JSON.stringify({
        limit: filters.limit || 10,
        offset: filters.offset || 0,
        search_attr: filters.search,
        // store_id: localStorage.getItem('store_id')
      });
    } else {
      const filtersObj = {
        limit: filters.limit || 10,
        offset: filters.offset || 0,
        // store_id: localStorage.getItem('store_id')
      };

      if (filters.sort && filters.sort.length > 0) {
        filtersObj.sort = filters.sort.map(item => ({
          colId: item.field,
          sort: item.sort
        }));
      }

      queryParams.filters = JSON.stringify(filtersObj);
    }
  }

  const response = await get(`${process.env.EXTENDED_URL}customer`, queryParams);
  return customerListGet(response);
};


export const CouponApiGetCouponValidate = async (data) => {
    const response = await post(`${process.env.EXTENDED_URL}/coupon/validate/`, data, "webhook");
    return getGenericModel(response);
};


export const CouponUsageLogApiPost = async (data) => {
    const response = await post(`${process.env.EXTENDED_URL}/generic/`, data, "webhook");
    return getGenericModel(response);
}

export const CouponRevokeApiPost = async (data) => {
    const response = await post(`${process.env.EXTENDED_URL}/coupon/revoke/`, data);
    return getGenericModel(response);
}

export const couponLogsApiGet = async (data) => {
    const response = await get(`${process.env.EXTENDED_URL}/coupon/logs`, data);
    return getGenericModel(response);
};

export const getAvailableCouponsForOrder = async (data, header = "global") => {
    let queryParams = {};

    if (data) {
        const filtersObj = {
            org_id: data.org_id,
            limit: data.limit || 20,
            page: data.offset !== undefined ? Math.floor(data.offset / (data.limit || 20)) + 1 : 1,
            want_to_fetch_mappings: true,
            is_active:true
        };

        if (data.search) {
            queryParams.filter_op = JSON.stringify({ code: "substring" });
            filtersObj.code = data.search;
        }

        if (data.sort && data.sort.length > 0) {
            filtersObj.sort = data.sort.map(item => ({
                colId: item.field,
                sort: item.sort
            }));
        }

        if (data.entity_type && data.entity_type.length > 0) {
            filtersObj.entity_type = data.entity_type;
        }

        if (data.entity_id && data.entity_id.length > 0) {
            filtersObj.entity_id = data.entity_id;
        }

        queryParams.filters = JSON.stringify(filtersObj);
    }

    const response = await get(`${process.env.EXTENDED_URL}/coupon/list`, queryParams, header);
    return getGenericModel(response);
};